import { styled } from "@mui/material/styles";
import { Banner } from "@UI";
import React from "react";
import { useTranslation } from "react-i18next";
const Title = styled("strong")({
    fontWeight: 600
});
export function ErrorPart({ part }) {
    const { t } = useTranslation();
    return /*#__PURE__*/ React.createElement(Banner, {
        tone: "error"
    }, /*#__PURE__*/ React.createElement(Title, null, t("chat.error.title")), /*#__PURE__*/ React.createElement("div", null, part.data.message));
}
